<template>
    <div>
        <h1 class="mt-4">
            Manuella registreringar
        </h1>

        <div class="content-container">
            <div class="row g-3 mb-6">
                <div class="col-24 col-md-6">
                    <input
                        type="text"
                        class="form-control new-list-group-field"
                        placeholder="Sök kund, massör, beskrivning"
                        v-model="settings.query.text"
                    />
                </div>

                <div class="col-24 col-md-8">
                    <div class="form-check pt-2">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            id="filter-is_processed"
                            v-model="settings.query.is_processed"
                        />
                        <label class="form-check-label" for="filter-is_processed">
                            Ej avklarade
                        </label>
                    </div>
                </div>

                <div class="col-24 col-md-4 d-flex align-items-center justify-content-start mt-1">
                    <span style="font-weight:400;">Från:</span>
                    <div class="form-check pt-2">
                        <input
                            class="form-control"
                            type="date"
                            id="filter-from"
                            v-model="settings.query.from_date"
                        />
                    </div>
                </div>

                <div class="col-24 col-md-4 d-flex align-items-center justify-content-start mt-1">
                    <span style="font-weight:400;">Till:</span>
                    <div class="form-check pt-2">
                        <input
                            class="form-control"
                            type="date"
                            id="filter-to"
                            v-model="settings.query.to_date"
                        />
                    </div>
                </div>

                <div class="col-24 col-md-2 d-flex justify-content-end align-items-start mt-4">
                    <button class="btn btn-primary btn-sm" @click="openExportModal()">
                        Spara Excel
                        <div class="tooltip-label">
                            Ladda ner en Excel-fil med manuella registreringar .
                        </div>
                    </button>
                </div>
            </div>

            <div class="custom-list-wrapper deviations-list">
                <list ref="list" :settings="settings" :query.sync="settings.query">
                    <div slot="item-row" slot-scope="props">
                        <deviations-list-item :key="'list-item-'+props.item.id" :deviation="props.item" @refresh="refresh()" />
                    </div>
                </list>
            </div>
        </div>
    </div>
</template>

<script>
import lister from '../../shared/mixins/lister'

import deviationsListItem from './deviations-list-item.vue'

export default {
    mixins: [lister],

    components: {
        deviationsListItem
    },

    props: {
        options: {
            required: true
        }
    },

    data () {
        return {
            settings: {
                url: '/deviations/list',
                query: {
                    text: '',
                    is_processed: null,
                    from_date: null,
                    to_date: null
                },
                columns: [
                    {
                        column: 'id',
                        name: 'ID',
                        class: 'col d-none d-md-flex col-md-1',
                        sortable: true,
                        default: true
                    },
                    {
                        column: 'created_at',
                        name: 'Inkommen',
                        class: 'col col-18 col-md-2',
                        sortable: true
                    },
                    {
                        column: 'customer_name',
                        name: 'Kund',
                        class: 'col col-18 col-md-3',
                        sortable: true
                    },
                    {
                        column: 'clinic_name_person',
                        name: 'Massör',
                        class: 'col col-18 col-md-3',
                        sortable: false
                    },
                    {
                        column: 'treatment_date',
                        name: 'Behandling',
                        class: 'col col-18 col-md-2',
                        sortable: true
                    },
                    {
                        column: 'reason',
                        name: 'Orsak',
                        class: 'col col-18 col-md-4',
                        sortable: true
                    },
                    {
                        column: 'comment',
                        name: 'Kommentar',
                        class: 'col col-18 col-md-8',
                        sortable: true
                    },
                    {
                        column: 'is_processed',
                        name: 'Klar',
                        class: 'col col-18 col-md-1',
                        sortable: true
                    }
                ],
                bulk_actions: [],
                export_fields: [
                    { column: 'id', name: 'ID' },
                    { column: 'created_at', name: 'Inkommet' },
                    { column: 'customer_name', name: 'Kund' },
                    { column: 'clinic.name_person', name: 'Massör' },
                    { column: 'signature_key', name: 'Signatur' },
                    { column: 'treatment_date', name: 'Behandlingsdatum' },
                    { column: 'duration.name', name: 'Behandlingslängd' },
                    { column: 'reasonNice', name: 'Orsak' },
                    { column: 'reason_description', name: 'Beskrivning' },
                    { column: 'comment', name: 'Kommentar' },
                    { column: 'is_processed', name: 'Avklarad' },
                    { column: 'is_processed_at', name: 'Avklarad datum' },
                    { column: 'is_autoresolved', name: 'Automatisk' }
                ]
            }
        }
    },

    computed: {},

    methods: {}
}
</script>
